<template>
  <div class="wrapper">
    <div class="container">
      <h3 class="h3"></h3>
      <div class="input-group">
        <h5>您的姓名</h5>
        <el-input v-model="form.userName" @input="userNameChange" placeholder="请输入姓名" maxlength="20"></el-input>
        <div class="error-msg" v-if="!userNameValid && form.userName">姓名必须是中文</div>
      </div>
      <div class="input-group input-group-area">
        <div class="tit">
          <span class="h5">所在地区</span>
          <span class="iconfont icon-position" @click="isShowMap = true" v-if="!isMobile" style="display: none;"></span>
        </div>
        <div class="area-box" v-if="isMobile">
          <div class="area-input" @click="clickProvincesTap">
            <span class="area-txt">{{chooseCity}}</span>
            <span class="iconfont icon-triangle"></span>
          </div>
          <div class="map-btn" @click="isShowMap = true" style="display: none;">
            <span class="iconfont icon-position"></span>
          </div>
        </div>
        <div class="area-select-box" v-else> 
          <!-- <p class="area-info" v-if="chooseCity">{{chooseCity}}</p> -->
          <el-select v-model="form.userProvinceCode" placeholder="请选择省份" @change="getProvince($event)">
            <el-option
              v-for="item in provinceL"
              :key="item.provinceCode"
              :label="item.provinceName"
              :value="item.provinceCode">
            </el-option>
          </el-select>
          <el-select v-model="form.userCityCode" placeholder="请选择市" @change="getCity($event)">
            <el-option
              v-for="item in cityL"
              :key="item.cityCode"
              :label="item.cityName"
              :value="item.cityCode">
            </el-option>
          </el-select>
          <el-select v-model="form.userCountyCode" placeholder="请选择区" @change="getArea($event)">
            <el-option
              v-for="item in areaL"
              :key="item.areaCode"
              :label="item.areaName"
              :value="item.areaCode">
            </el-option>
          </el-select>
          <el-select v-model="form.userTownCode" placeholder="请选择街道" @change="getStreet($event)">
            <el-option
              v-for="item in streetL"
              :key="item.streetCode"
              :label="item.streetName"
              :value="item.streetCode">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="input-group">
        <div style="display:flex;align-item:center;">
          <h5>详细地址</h5>
        </div>
        <el-input type="textarea" v-model="form.userAddress" :rows="3" maxlength="100" resize="none"></el-input>
      </div>
      <template v-if="form.distributionType==1">
        <div class="input-group">
          <h5>微信</h5>
          <el-input v-model="form.serviceWechat" placeholder="选填" maxlength="20"></el-input>
        </div>
        <div class="input-group">
          <h5>上传头像</h5>
          <VantUploadImg :shopCode="shopCode" :value="form.serviceUrl" :limit="1" @valChange="getAvatarImages" class="avatar" />
        </div>
        <div class="input-group">
          <h5>上传微信二维码</h5>
          <VantUploadImg :shopCode="shopCode" :value="form.wechatUrl" :limit="1" @valChange="getWechatCodeImages" class="avatar" />
        </div>
      </template>

      <!-- 列表展示 -->
      <section class="showAddressList">
          <van-action-sheet v-model="showList">
              <div class="titleBox">
                  <p></p>
                  <p class="title">所在地区</p>
                  <p class="confirm" @click="showList = false">取消</p>
              </div>
              <!-- 省市区街道的标题 -->
              <div class="showAddress bd">
                  <div class="showArea minVideoViewBox">
                      <p class="tipTxt" @click="chooseProvince" v-show='tit1'>{{chooseTit1}}</p>
                      <p class="tipTxt" @click="chooseCitys" v-show='tit2'>{{chooseTit2}}</p>
                      <p class="tipTxt" @click="chooseArea" v-show='tit3'>{{chooseTit3}}</p>
                      <p class="tipTxt" @click="chooseStreet" v-show='tit4'>{{chooseTit4}}</p>
                  </div>
              </div>
              <div class="title-bar"></div>
              <!-- 省市区街道的标题 -->
              <div class="chooseList">
                  <!-- 省市区列表 --->
                  <div class="addressList">
                      <ul v-show="showProvince">
                          <li v-for="(item, index) in provinceL" :key="index" @click="getProvince(item, index)">
                              <div class="items">
                                  <div>{{item.provinceName}}</div>
                                  <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon1 == index}"></div>
                              </div>
                          </li>
                      </ul>
                      <ul v-show="showCity">
                          <li v-for="(item, index) in cityL" :key="index" @click="getCity(item, index)">
                              <div class="items">
                                  <div>{{item.cityName}}</div>
                                  <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon2 == index}"></div>
                              </div>
                          </li>
                      </ul>
                      <ul v-show="showArea">
                          <li v-for="(item, index) in areaL" :key="index" @click="getArea(item, index)">
                              <div class="items">
                                  <div>{{item.areaName}}</div>
                                  <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon3 == index}"></div>
                              </div>
                          </li>
                      </ul>
                      <ul v-show="showStreet">
                          <li v-for="(item, index) in streetL" :key="index" @click="getStreet(item, index)">
                              <div class="items">
                                  <div>{{item.streetName}}</div>
                                  <div class="checkIcon iconfont icon-Tick" :class="{showIcon: activeIcon4 == index}"></div>
                              </div>
                          </li>
                      </ul>
                  </div>
              </div>
          </van-action-sheet>
      </section>

      <!-- 腾讯地图定位弹窗 -->
      <AMap :visibleMap="isShowMap" @cancel="isShowMap=false;" @confirm='confirmMap'></AMap>

      <!-- 地图 -->
      <!-- <AMap style="height: 500px;" v-show="isShowMap" @isShowMap="isShowMap = false"
          ref="mapSearch"
          :value="isShowMap"
          :longitude="form.shopLongitude"
          :latitude="form.shopLongitude"
          @updateLocation="updateLocation"
          @updateAllLocation="updateAllLocation" /> -->
    </div>
    <div class="footer-bar"></div>
    <div class="footer">
      <div class="submit-btn disabled-btn" v-if="!form.userName || !userNameValid || !form.userProvinceCode || !form.userCityCode || !form.userAddress">下一步</div>
      <div class="submit-btn" @click="onSubmit" v-else>下一步</div>
    </div>
    <ContactBtn />
  </div>
</template>

<script>
  import AMap from '@/components/AMap.vue';
  import VantUploadImg from '@/components/VantUploadImg.vue';
  import { validChinese } from '@/utils/validate'
  import { getProvinceByName, getCityByName, getAreaByName, getStreetByName, getProvince, getCity, getArea, getStreet, shopBasic, mallBasic } from '@/api/baseinfo';
  import { getGeoCode } from '@/api/user';
  import { addDistributionInfo, getLoginDistributionInfo } from '@/api/distribution/index';
import { TimeSelect } from 'element-ui';
  export default {
    name: 'baseinfo',
    components: {
      AMap,
      "VantUploadImg": VantUploadImg,
    },
    data() {
      return {
        userCode: sessionStorage.getItem('userCode')||null,
        shopCode: sessionStorage.getItem('shopCode'),
        isShowMap: false,
        isMobile: false,
        // 省市区
        chooseCity: "请选择",
        provinceL: [], //省数据列表
        cityL: [],
        areaL: [],
        streetL: [],
        showProvince: true, //是否显示模块
        showCity: false,
        showArea: false,
        showStreet: false,
        chooseTit1: "请选择省", //占位
        chooseTit2: "请选择市",
        chooseTit3: "请选择区",
        chooseTit4: "请选择街道",
        tit1: true, //切换标题
        tit2: false,
        tit3: false,
        tit4: false,
        province: "", //当前选择值
        Nextcity: "",
        district: "",
        street: "",
        currentType: 1, //当前操作类型 1:省:，2:市，3：区，4：街道
        parentId: 1, //父级id
        currentAdsId: '', //当前选择地址id
        showList: false, //显示地址列表
        activeIcon1: -1, //省 icon状态
        activeIcon2: -1,
        activeIcon3: -1,
        activeIcon4: -1,
        userNameValid: false,
        form: {
          distributionType: sessionStorage.getItem('distributionType')||null,
          partnerCode: sessionStorage.getItem('partnerCode')||null,
          userName: null,
          serviceWechat: null,
          serviceUrl: null,
          wechatUrl: null,
          shopLongitude: null,
          shopLatitude: null,
          userProvinceCode: null,
          userCityCode: null,
          userCountyCode: null,
          userTownCode: null,
          userAddress: null,
          shopCode: sessionStorage.getItem('shopCode')||null
        },
      };
    },
    created() {
      // this.mobileTerminal((data) => {
      //   this.isMobile = data;
      // })
      // this.getProvinceList();

      let industryInfo = JSON.parse(sessionStorage.getItem('industryInfo'));
      let baseInfo = JSON.parse(sessionStorage.getItem('baseInfo')); 
      let areaInfo = JSON.parse(sessionStorage.getItem('areaInfo'));
      let propertyInfo = JSON.parse(sessionStorage.getItem('propertyInfo'));
      this.mobileTerminal((data) => {
        this.isMobile = data;
      })
      this.propertyInfo = propertyInfo ? propertyInfo : {};
      this.industryInfo = industryInfo || {};
      if(baseInfo) {
        this.form = {
          shopLicenseName: baseInfo.shopLicenseName,
          shopName: baseInfo.shopName,
          contractName: baseInfo.contractName,
          shopProvience: baseInfo.shopProvience,
          shopCity: baseInfo.shopCity,
          shopCounty: baseInfo.shopCounty,
          shopStreet: baseInfo.shopStreet,
          shopAddress: baseInfo.shopAddress,
        }
        this.contractNameValid = true;
        if(baseInfo.shopProvience !== '') {
          this.getProvinceList();
          this.getCityList(baseInfo.shopProvience);
        }
        if(baseInfo.shopCity !== '') {
          this.getAreaList(baseInfo.shopCity);
        }
        if(baseInfo.shopCounty !== '') {
          this.getStreetList(baseInfo.shopCounty);
        }
      } else {
        this.getProvinceList();
      }
      if(areaInfo) {
        this.form.shopLongitude = sessionStorage.getItem('longitude');
        this.form.shopLatitude = sessionStorage.getItem('latitude');
        if(areaInfo.province) {
          this.chooseCity = areaInfo.province+areaInfo.Nextcity+areaInfo.district+areaInfo.street;
        }
        this.chooseTit1 = areaInfo.province;
        this.chooseTit2= areaInfo.Nextcity;
        this.chooseTit3= areaInfo.district;
        this.chooseTit4 = areaInfo.street;
        this.tit1 = true;
        this.tit2 = true;
        this.tit3 = true;
        this.tit4 = true;
      }
      
    },
    methods: {
      getAvatarImages(files) {
        this.form.serviceUrl = files;
      },
      getWechatCodeImages(files) {
        this.form.wechatUrl = files;
      },
      confirmMap(e){
        if(e.lat&&e.lng) {
          this.getLocation(e.lat, e.lng);
          this.isShowMap = false;
        } else {
          this.Toast('请选择地址~')
        }
      },
      getLocation(latitude, longitude) {
        let params = {
          location: latitude+','+longitude
        }
        getGeoCode(params).then(res=>{
          let data = res.data.result;
          if(data&&data.address_component) {
            let addressCont = data.address_component;
            let town = data.address_reference.town.title;
            let address = data.address_reference.landmark_l2.title;
            addressCont.district = addressCont.district==addressCont.city||!addressCont.district?data.address_reference.town.title:addressCont.district;
            town = town==addressCont.district||!addressCont.district?'':town;
            this.updateAllLocation(longitude, latitude, address, addressCont.province, addressCont.city, addressCont.district, town)
          }
        })
      },
      updateAllLocation(lng, lat, address,provinceName,cityName,areaName,streetName) { // 地图搜索选址
        let userAddress = '';
        if(provinceName=='北京市'||provinceName=='重庆市'||provinceName=='天津市'||provinceName=='上海市'){
          cityName = provinceName;
          provinceName = provinceName.substring(0,2);
        }
        this.form.shopLongitude = lng;
        this.form.shopLatitude = lat;
        sessionStorage.setItem('longitude', lng);
        sessionStorage.setItem('latitude', lat);
        streetName = streetName?streetName:''
        if(cityName=='北京市'||cityName=='重庆市'||cityName=='天津市'||cityName=='上海市'){
          userAddress = address.replace(cityName+cityName+areaName,"");
        }else{
          userAddress = address.replace(provinceName+cityName+areaName,"");
        }
        let areaInfo = {
          province: provinceName,
          Nextcity: cityName,
          district: areaName,
          street: streetName
        }
        sessionStorage.setItem('areaInfo', JSON.stringify(areaInfo));
        this.form.userAddress = userAddress;
        this.chooseCity = provinceName+cityName+areaName+streetName;
        this.chooseTit1 = provinceName;
        this.chooseTit2 = cityName;
        this.chooseTit3 = areaName;
        this.chooseTit4 = streetName;
        this.getProvinceList()
        getProvinceByName(provinceName).then(res => {
          let data = res.data;
          this.form.userProvinceCode = data[0].provinceCode;
          this.getCityList(this.form.userProvinceCode);
          getCityByName(cityName).then(cityRes => {
            let cityData = cityRes.data;
            this.form.userCityCode = cityData[0].cityCode;
            this.getAreaList(this.form.userCityCode);
            getAreaByName(areaName).then(areaRes => {
              let areaNameData = areaRes.data;
              let listItem = areaNameData.filter(item=>{
                return item.cityCode == this.form.userCityCode
              })
              this.form.userCountyCode = listItem[0].areaCode;
              sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
              this.getStreetList(this.form.userCountyCode);
              if(streetName){
                getStreetByName(streetName).then(streetRes => {
                  let streetNameData = streetRes.data;
                  let streetListItem = streetNameData.filter(item=>{
                    return item.areaCode == this.form.userCountyCode
                  })
                  this.form.userTownCode = streetListItem[0].streetCode;
                  sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
                })
              }else{
                this.form.userTownCode = null;
              }
            })
          })
        })
        
      },
      updateLocation(lng, lat, address) { // 地图搜索选址
        this.form.shopLongitude = lng;
        this.form.shopLatitude = lat;
      },
      userNameChange(value) {
        this.form.userName = this.trimSpecial(this.form.userName);
        this.userNameValid = validChinese(value);
      },
      // 点击选择 省市区 展示弹窗
      clickProvincesTap() {
        this.showList = true;
        this.showProvince = true;
        this.getProvinceList();
      },
      ///////////<!-- 选择省市区街道事件 -->
      //当用户点击某个省事件 根据省的id获取市
      getProvince(item, index) {
        if(this.isMobile) {
          this.province = item.provinceName;
          this.chooseTit1 = item.provinceName;
          this.activeIcon1 = index; //当前选中icon
          this.currentType = 2;
          this.form.userProvinceCode = item.provinceCode;
          this.getCityList(item.provinceCode);
          // chooseTit1: "请选择省", //占位
          this.chooseTit2 = "请选择市";
          this.chooseTit3 = "请选择区";
          this.chooseTit4 = "请选择街道";
        } else {
          let idx = this.provinceL.map(f => f.provinceCode).indexOf(item);
          this.province = this.provinceL[idx].provinceName;
          this.form.userProvinceCode = item;
          this.form.userCityCode = undefined;
          this.form.userCountyCode = undefined;
          this.form.userTownCode = undefined;
          this.getCityList(item);
        }
        sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
      },
      //当用户点击某个市事件 根据市的id获取区
      getCity(item, index) {
        if(this.isMobile) {
          this.Nextcity = item.cityName;
          this.chooseTit2 = item.cityName;
          this.activeIcon3 = -1; //重置icon状态
          this.activeIcon2 = index; //当前选中icon
          this.currentType = 3;
          this.form.userCityCode = item.cityCode;
          this.getAreaList(item.cityCode);
          this.chooseTit3 = "请选择区";
          this.chooseTit4 = "请选择街道";
        } else {
          let idx = this.cityL.map(f => f.cityCode).indexOf(item);
          this.Nextcity = this.cityL[idx].cityName;
          this.form.userCityCode = item;
          this.form.userCountyCode = undefined;
          this.form.userTownCode = undefined;
          this.getAreaList(item);
        }
        sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
        this.isShowList();
      },
      //当用户点击某个区事件 根据区的id获取街道
      getArea(item, index) {
        if(this.isMobile) {
          this.district = item.areaName;
          this.chooseTit3 = item.areaName;
          this.activeIcon4 = -1;
          this.activeIcon3 = index;
          this.currentType = 4;
          this.form.userCountyCode = item.areaCode;
          this.getStreetList(item.areaCode);
          this.chooseTit4 = "请选择街道";
        } else {
          let idx = this.areaL.map(f => f.areaCode).indexOf(item);
          this.district = this.areaL[idx].areaName;
          this.form.userCountyCode = item;
          this.form.userTownCode = undefined;
          this.getStreetList(item);
        }
        sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
        this.isShowList();
      },
      //用户点击镇，隐藏弹窗
      getStreet(item, index) {
        if(this.isMobile) {
          this.street = item.streetName;
          this.chooseTit4 = item.streetName;
          this.activeIcon4 = index;
          this.form.userTownCode = item.streetCode;
        } else {
          let idx = this.streetL.map(f => f.streetCode).indexOf(item);
          this.street = this.streetL[idx].streetName;
          this.form.userTownCode = item;
        }
        sessionStorage.setItem('baseInfo', JSON.stringify(this.form));
        this.isShowList();
        this.showList = false;
      },
      //弹窗消失 保存当前选择值
      isShowList() {
        let totalCity = '';
        if(this.isMobile) {
          totalCity = `${this.province}${this.Nextcity}${this.district}${this.street}`;
        } else {
          totalCity = `${this.province}，${this.Nextcity}，${this.district}，${this.street}`;
        }
        this.chooseCity = totalCity;
        // this.showList = false;
        let areaInfo = {
          province: this.province,
          Nextcity: this.Nextcity,
          district: this.district,
          street: this.street
        }
        sessionStorage.setItem('areaInfo', JSON.stringify(areaInfo));
      },
      //点击省市区标题显示/隐藏相关内容 形成回退效果
      chooseProvince() {
          this.showProvince = true;
          this.showCity = false;
          this.showArea = false;
          this.showStreet = false;
          this.activeIcon2 = -1; //重置
          if(this.tit1 && this.form.userProvinceCode) this.getProvinceList();
      },
      chooseCitys() { //选择市
          this.showProvince = false;
          this.showCity = true;
          this.showArea = false;
          this.showStreet = false;
          this.activeIcon3 = -1; //重置
          if(this.tit2 && this.form.userProvinceCode) this.getCityList(this.form.userProvinceCode);
      },
      chooseArea() { //选择区
          this.showProvince = false;
          this.showCity = false;
          this.showArea = true;
          this.showStreet = false;
          if(this.tit3 && this.form.userCityCode) this.getAreaList(this.form.userCityCode);
      },
      chooseStreet() { //选择街道
        this.showProvince = false;
        this.showCity = false;
        this.showArea = false;
        this.showStreet = true;
        if(this.tit4 && this.form.userCountyCode) this.getStreetList(this.form.userCountyCode);
      },
      getProvinceList() {
        getProvince().then(res => {
          res.data.forEach((item, index) => {
            if(item.provinceCode == this.form.userProvinceCode) {
              this.activeIcon1 = index;
            }
          })
          this.provinceL = res.data;
        })
      },
      getCityList(provinceCode) {
        getCity(provinceCode).then(res => {
          res.data.forEach((item, index) => {
            if(item.cityCode == this.form.userCityCode) {
              this.activeIcon2 = index;
            }
          })
          this.cityL = res.data;
          this.handleByType(res.data);
        })
      },
      getAreaList(cityCode) {
        getArea(cityCode).then(res => {
          res.data.forEach((item, index) => {
            if(item.areaCode == this.form.userCountyCode) {
              this.activeIcon3 = index;
            }
          })
          this.areaL = res.data;
          this.handleByType(res.data);
        })
      },
      getStreetList(areaCode) {
        getStreet(areaCode).then(res => {
          res.data.forEach((item, index) => {
            if(item.streetCode == this.form.userTownCode) {
              this.activeIcon4 = index;
            }
          })
          this.streetL = res.data;
          this.handleByType(res.data);
        })
      },
      //根据当前操作类型处理数据
      handleByType(datas) {
          if(!this.isMobile) return;
          if(datas.length == 0) {
              this.isShowList();
              return;
          }
          switch(this.currentType) {
              case 1: //省
                  this.provinceL = datas;
                  break;
              case 2: //市
                  this.cityL = datas;
                  this.citySelected = this.cityL[0].id;
                  this.showProvince = false;
                  this.showCity = true;
                  this.tit2 = true;
                  this.areaL = [];
                  break;
              case 3: //区
                  this.areaL = datas;
                  this.areaSelected = this.areaL[0].id;
                  this.showCity = false;
                  this.showArea = true;
                  this.tit3 = true;
                  this.streetL = [];
                  break;
              case 4: //街道
                  this.streetL = datas;
                  this.streetSelected = this.streetL[0].id;
                  this.showCity = false;
                  this.showArea = false;
                  this.showStreet = true;
                  this.tit4 = true;
                  break;
          }
      },
      getDistributionInfo() {
        getLoginDistributionInfo({"userCode":this.userCode,"shopCode":this.shopCode}).then(res=>{
          // 系统状态 未提交过基本信息 返回null  [1090-待提交资质、1110-待初审、1111-初审失败、1130-易宝待审核、1131-易宝审核成功、1132-易宝审核失败、2001营业中(入驻成功)]
          if(res.code===200){
            let data = res.data;
            if(data.distributionInfo.systemStatus==='1090') {
              if(data.distributionInfo.isQualification===1){
                this.$router.push({
                  path: '/distribution/qualifications-list'
                })
              } else {
                this.$router.push({
                  path: '/distribution/baseinfo-auth'
                })
              }
            } else {
              this.$router.push({
                path: '/distribution/apply-results'
              })
            }
          }
        })
      },
      onSubmit() {
        // if(!this.form.shopLongitude || !this.form.shopLatitude) return this.Toast('请选择所在地区经纬度~');
        this.form.partnerCode = !this.form.partnerCode||this.form.partnerCode==='null'?null:this.form.partnerCode;
        addDistributionInfo(this.form).then(res => {
          if(res.code == 200) {
            this.getDistributionInfo();
            // this.$router.push({
            //   path: '/distribution/baseinfo-auth'
            // })
            sessionStorage.removeItem('baseInfo');
            sessionStorage.removeItem('areaInfo');
            sessionStorage.removeItem('longitude');
            sessionStorage.removeItem('latitude');
            sessionStorage.removeItem('partnerCode');
          } else {
            this.Toast(res.msg);
          }
        })
      },
      getDistributionInfo() {
        getLoginDistributionInfo({"userCode":this.userCode,"shopCode":this.shopCode}).then(res=>{
          if(res.code===200){
            if(!res.data){
              this.$router.push({
                path: '/distribution/baseinfo-auth'
              })
            } else {
              let data = res.data;
              if(data.distributionInfo.systemStatus==='1090') {
                if(data.distributionInfo.isQualification===1){
                  this.$router.push({
                    path: '/distribution/qualifications-list'
                  })
                } else {
                  this.$router.push({
                    path: '/distribution/baseinfo-auth'
                  })
                }
              } else {
                this.$router.push({
                  path: '/distribution/apply-results'
                })
              }
            }
          } else {
            this.Toast(res.msg||'请试试重新登录~');
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
@media screen and (max-width:750px){
  .container{
    padding-top: .05rem;
    .h3{
      width: 16.7rem;
      margin: .8rem auto 1.4rem;
      font-size: 1.2rem;
      color: #222222;
    }
  }
  .input-group{
    width: 16.7rem;
    margin: 0 auto 1.2rem;
    h5, .h5{
      margin-bottom: .4rem;
      font-size: .7rem;
      color: #666;
      font-weight: 400;
    }
    /deep/ .el-input__inner, /deep/ .el-textarea__inner{
      border-radius: .5rem;
      border: .05rem solid #ddd;
      font-size: .8rem;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
      font-size: .8rem;
    }
    /deep/ .el-input__inner{
      height: 2.4rem;
    }
  }
  .icon-position{
    font-size: 1rem;
    color: #47B6C7;
    cursor: pointer;
  }
  .input-group-area{
    .tit{
      line-height: 1.2rem;
      margin-bottom: .4rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .h5{
        margin-bottom: 0;
      }
    }
    .area-box{
      display: flex;
      cursor: pointer;
      .area-input{
        // width: 11rem;
        width: 100%;
        height: 2.4rem;
        padding: 0 .75rem;
        // padding:0 1.65rem 0 .75rem;
        // border-radius: .5rem 0 0 .5rem;
        border-radius: .5rem;
        border: .05rem solid #ddd;
        position: relative;
        @include flex(space-between);
        @include text-overflow();
        .area-txt{
          // width: 10rem;
          width: 100%;
          height: 2.4rem;
          line-height: 2.4rem;
          font-size: .8rem;
          color: #222;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-Tick{
          font-size: .6rem;
          color: #222;
          position: absolute;
          top: .9rem;
          right: .6rem;
          color: #47B6C7;
        }
      }
      .map-btn{
        width: 3.9rem;
        height: 2.4rem;
        border-radius: 0 .5rem .5rem 0;
        border: .05rem solid #ddd;
        border-left: 0;
        @include flex();
      }
    }
    .area-select-box{
      .area-info{
        line-height: 1.4;
        margin: .25rem 0 .5rem;
        font-size: .75rem;
        color: #222;
        text-align: left;
      }
      .el-select{
        width: 8.2rem;
        margin-bottom: .25rem;
      }
    }
  }

  // 省市区街道弹窗列表
  .showAddressList {
      .title-bar{
        width: 100%;
        height: 4.9rem;
      }
      .titleBox {
          width: 100%;
          height: 2.7rem;
          @include flex();
          // @include fcc;
          font-size: .8rem;
          color: #999;
          background: #F4F4F4;
          padding: 0 .75rem;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          >p {
              flex: 1;
          }
          .title {
              font-size: .9rem;
              color: #222;
              text-align: center;
          }
          .confirm {
              color: #999;
              text-align: right;
              cursor: pointer;
          }
      }
      .showAddress {
        width: 100%;
        height: 2.2rem;
        font-size: .7rem;
        color: #222;
        padding: .75rem;
        box-sizing: border-box;
        position: absolute;
        top: 2.7rem;
        left: 0;
        z-index: 4;
        background: #fff;
        border-bottom: .05rem solid #ddd;
        .showArea {
          line-height: 1;
            font-size: .7rem;
            color: #222;
            @include scrollArea();
            @include flex-align();
            p {
                margin-right: .75rem;
            }
        }
      .miniStreamView{
          width:4rem;
          height:4rem;
          display: inline-block;
          background:pink;
          margin:.3rem;
      }
        .tipTxt {
            font-size: .7rem;
            color: #47B6C7;
            position: relative;
            &::after {
                content: '';
                // @include cl;
                bottom: -0.7rem;
                width: 2.35rem;
                height: .1rem;
                background: #999;
                border-radius:.1rem ;
                transition: all 0.1s;
            }
        }
    }
      .chooseList {
          // @include sc(1.6rem, $fc);
          font-size: .8rem;

          .bd {
              &::after {
                  border-color: #E5E5E5;
                  left: .75rem;
                  right: .75rem;
              }
          }
          .addressList {
              ul {
                  li {
                      padding: .5rem .75rem;
                      .items {
                        font-size: .7rem;
                        color: #222;
                        @include flex(space-between);
                          // @include fcb;
                          .checkIcon {
                            width: .7rem;
                            height: .5rem;
                              // @include fcc;
                              display: none;
                              img {
                                width: 100%;
                                height: 100%;
                              }
                              color: #47B6C7;
                          }
                          .showIcon {
                              display: block;
                          }
                      }
                  }
              }
          }
      }
  }
  .error-msg{
    line-height: 1.1rem;
    font-size: .65rem;
    color: #FF4743;
  }
}
@media screen and (max-width:750px){
  .footer{
    bottom: 0;
  }
}
@media screen and (min-width:750px){
  .container{
    padding-top: 1px;
    .h3{
      width: 334px;
      margin: 28px auto;
      font-size: 24px;
      color: #222222;
    }
  }
  .wrapper{
    .container{
      //height: 60vh;
    }
  }
  .input-group{
    width: 334px;
    margin: 0 auto 24px;
    h5, .h5{
      margin-bottom: 8px;
      font-size: 14px;
      color: #666;
      font-weight: 400;
    }
    /deep/ .el-input__inner, /deep/ .el-textarea__inner{
      border-radius: 10px;
      border: 1px solid #ddd;
      font-size: 16px;
      color: #222;
    }
    /deep/ .el-input__inner::-webkit-input-placeholder, /deep/ .el-textarea__inner::-webkit-input-placeholder{
      font-size: 16px;
    }
    /deep/ .el-input__inner{
      height: 48px;
    }
  }
  .icon-position{
    font-size: 20px;
    color: #47B6C7;
    cursor: pointer;
  }
  .input-group-area{
    .tit{
      line-height: 24px;
      margin-bottom: 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .h5{
        margin-bottom: 0;
      }
    }
    .area-box{
      display: flex;
      cursor: pointer;
      .area-input{
        width: 220px;
        height: 48px;
        padding: 0 15px;
        // padding:0 33px 0 15px;
        border-radius: 10px 0 0 10px;
        border: 1px solid #ddd;
        position: relative;
        @include flex(space-between);
        @include text-overflow();
        .area-txt{
          width: 200px;
          height: 48px;
          line-height: 48px;
          font-size: 16px;
          color: #222;
          text-align: left;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-Tick{
          font-size: 12px;
          color: #222;
          position: absolute;
          top: 18px;
          right: 12px;
          color: #47B6C7;
        }
      }
      .map-btn{
        width: 78px;
        height: 48px;
        border-radius: 0 10px 10px 0;
        border: 1px solid #ddd;
        border-left: 0;
        @include flex();
      }
    }
    .area-select-box{
      .area-info{
        line-height: 1.4;
        margin: 5px 0 10px;
        font-size: 15px;
        color: #222;
        text-align: left;
      }
      .el-select{
        width: 164px;
        margin-bottom: 5px;
      }
    }
  }

  // 省市区街道弹窗列表
  .showAddressList {
      .title-bar{
        width: 100%;
        height: 98px;
      }
      .titleBox {
          width: 100%;
          height: 54px;
          @include flex();
          // @include fcc;
          font-size: 16px;
          color: #999;
          background: #F4F4F4;
          padding: 0 15px;
          box-sizing: border-box;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          >p {
              flex: 1;
          }
          .title {
              font-size: 18px;
              color: #222;
              text-align: center;
          }
          .confirm {
              color: #999;
              text-align: right;
              cursor: pointer;
          }
      }
      .showAddress {
        width: 100%;
        height: 44px;
        font-size: 14px;
        color: #222;
        padding: 15px;
        box-sizing: border-box;
        position: absolute;
        top: 54px;
        left: 0;
        z-index: 4;
        background: #fff;
        border-bottom: 1px solid #ddd;
        .showArea {
          line-height: 1;
            font-size: 14px;
            color: #222;
            @include scrollArea();
            @include flex-align();
            p {
                margin-right: 15px;
            }
        }
      .miniStreamView{
          width:80px;
          height:80px;
          display: inline-block;
          background:pink;
          margin:6px;
      }
        .tipTxt {
            font-size: 14px;
            color: #47B6C7;
            position: relative;
            &::after {
                content: '';
                // @include cl;
                bottom: -14px;
                width: 47px;
                height: 2px;
                background: #999;
                border-radius:2px ;
                transition: all 0.1s;
            }
        }
    }
      .chooseList {
          // @include sc(32px, $fc);
          font-size: 16px;

          .bd {
              &::after {
                  border-color: #E5E5E5;
                  left: 15px;
                  right: 15px;
              }
          }
          .addressList {
              ul {
                  li {
                      padding: 10px 15px;
                      .items {
                        font-size: 14px;
                        color: #222;
                        @include flex(space-between);
                          // @include fcb;
                          .checkIcon {
                            width: 14px;
                            height: 10px;
                              // @include fcc;
                              display: none;
                              img {
                                width: 100%;
                                height: 100%;
                              }
                              color: #47B6C7;
                          }
                          .showIcon {
                              display: block;
                          }
                      }
                  }
              }
          }
      }
  }
  .error-msg{
    line-height: 22px;
    font-size: 13px;
    color: #FF4743;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/distribution/baseinfo.vue